/* lg-delivery-picker.js - ETD spec s1 (McKyle rulings 1 Sep 2026).
   Customer-chosen delivery date on the PDP. Reads state from the badge root's
   data-* (set in Liquid), reuses the badge's working-day + holiday helpers via
   window.LG_EDB, writes line-item properties into the product form so the choice
   rides the line to cart/checkout/order (Cin7 bridge reads _delivery_date).
   Rules: earliest by state (in-stock: zone max working days; incoming: incoming
   date then zone; layby: end of period then zone). GARNET-3 (24 Sep): the
   special-order +8/14 weeks basis is removed with custom order. Latest = earliest + 30 days. Working days only. Required:
   submit is blocked until a date is chosen; earliest is pre-selected. Layby not
   offered on sale or sold-out items (policy 1 Sep). */
(function () {
  "use strict";
  var PROPS = ["Delivery date", "Delivery province", "Payment plan", "_delivery_date", "_etd_basis"];
  function findForm(root) {
    var pi = root.closest("product-info") || document;
    /* Two /cart/add forms exist on a Dawn PDP; the installments form precedes the
       real one in DOM order, so a combined selector picked the wrong one (measured
       1 Sep). Prefer product-form explicitly. */
    return pi.querySelector('product-form form[action*="/cart/add"]') || pi.querySelector('form[action*="/cart/add"]');
  }
  function init(root) {
    if (root.dataset.lgPickerReady) return;
    var LG = window.LG_EDB; if (!LG) return;
    var region = root.querySelector(".lg-edb__region:not(.lg-edp__months):not(.lg-edp__date)");
    var payWrap = root.querySelector(".lg-edp__pay");
    var monthsWrap = root.querySelector(".lg-edp__months-wrap");
    var months = root.querySelector(".lg-edp__months");
    var dateWrap = root.querySelector(".lg-edp__date-wrap");
    var dateSel = root.querySelector(".lg-edp__date");
    var note = root.querySelector(".lg-edp__note");
    if (!region || !dateSel) return;
    /* Block 102 (10 Sep): READ AT CALL TIME, NOT AT INIT.
       These five were consts closed over on first paint, so the picker answered
       for the page-load variant for the rest of the session - it never moved at
       all, while the badge above it moved one click late. They are functions
       now, and rebuild() re-reads them; product-info.js refreshes the data-* on
       the root from the section render and fires lg:variant-state, in the same
       turn as the button and the badge.
       Block 94 (9 Sep): the BASIS flag. data-sold-out is availability, which is
       true for a continue-selling variant at zero stock, so it read every
       on-order item as in-stock. data-no-stock is quantity
       when inventory is tracked. soldOut is kept for the layby gate below,
       which is a policy rule about sold-out items and not about the basis. */
    function soldOut() { return root.dataset.soldOut === "true"; }
    function noStock() { return root.dataset.noStock === "true"; }
    function onSale() { return root.dataset.onSale === "true"; }
    function incoming() { return root.dataset.incomingDate || ""; }
    /* No picker when the variant is sold out (GARNET-3: the badge is hidden
       then too), or when there is nothing to date it from - no stock and no
       incoming PO. Block 102: this was an early return out of init(), so one
       such variant on first paint left the picker unbuilt for every later
       variant. It is a per-render test now. */
    function datable() { return !soldOut() && !(noStock() && !incoming()); }
    function laybyAllowed() { return !soldOut() && !onSale(); }
    var form = findForm(root);
    function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
    function parseISO(s) { var p = s.split("-"); return new Date(+p[0], +p[1] - 1, +p[2]); }
    function addMonths(d, n) { var x = LG.cloneDate(d); x.setMonth(x.getMonth() + n); return x; }
    function plan() { var r = root.querySelector('input[name="lg-edp-pay"]:checked'); return (r && laybyAllowed()) ? r.value : "full"; }
    function basis() { if (noStock() && incoming()) return "incoming"; return "in-stock"; }
    function fastCourier() { return root.dataset.fastCourier === "true"; }
    /* 17 Sep: GE ships First Freight, capped at 4-5 working days in every
       province. Same Math.min cap as the badge (lg-estimated-delivery-badge
       .liquid, calculateDelivery), reading the same numbers off window.LG_EDB,
       so the quoted window and the dated <select> cannot disagree. A province
       already inside the cap keeps its own faster window. */
    function zoneDays(area) {
      if (!fastCourier()) return { min: area.minWorkingDays, max: area.maxWorkingDays };
      var cap = LG.CONFIG.fastCourier;
      return { min: Math.min(area.minWorkingDays, cap.minWorkingDays), max: Math.min(area.maxWorkingDays, cap.maxWorkingDays) };
    }
    /* 17 Sep: the dispatch lead the badge has always applied (lg-estimated-
       delivery-badge.liquid, calculateDelivery) but this file did not, so the
       quoted window and the earliest dateable day disagreed by a working day
       or two for every LG product. 1 working day before the cut-off hour, 2
       after, read off the shared CONFIG so the numbers live in one place.
       Fast courier is door-to-door and takes no lead at all. */
    function dispatchDays() {
      if (fastCourier()) return 0;
      var c = LG.CONFIG;
      return new Date().getHours() >= c.cutOffHour ? c.dispatchWorkingDaysAfterCutoff : c.dispatchWorkingDaysBeforeCutoff;
    }
    function earliest() {
      var area = LG.CONFIG.deliveryAreas[region.value]; if (!area) return null;
      var days = zoneDays(area);
      var base = today();
      if (plan() === "layby") { base = addMonths(base, parseInt(months.value, 10) || 2); }
      else { if (noStock() && incoming()) { var inc = parseISO(incoming()); if (inc > base) base = inc; } /* 8 Sep: incoming PO date only moves the date when there is no stock; stock on hand wins. Block 94: noStock, not soldOut */ }
      return LG.addWorkingDays(base, dispatchDays() + days.max);
    }
    function fmt(d) { return d.toLocaleDateString("en-ZA", { weekday: "short", day: "numeric", month: "short", year: "numeric" }); }
    function ensure(name) { var el = form.querySelector('input[name="properties[' + name + ']"]'); if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = "properties[" + name + "]"; form.appendChild(el); } return el; }
    function clearProps() { if (form) PROPS.forEach(function (n) { var el = form.querySelector('input[name="properties[' + n + ']"]'); if (el) el.remove(); }); root.dataset.lgDateChosen = "false"; }
    function writeProps() {
      if (!form) return; var iso = dateSel.value; if (!iso) return clearProps();
      var area = LG.CONFIG.deliveryAreas[region.value]; var p = plan();
      ensure("Delivery date").value = fmt(parseISO(iso));
      ensure("Delivery province").value = area ? area.label : "";
      ensure("Payment plan").value = p === "layby" ? "Layby - " + months.value + " months" : "Full payment";
      ensure("_delivery_date").value = iso;
      ensure("_etd_basis").value = basis();
      root.dataset.lgDateChosen = "true"; if (note) note.hidden = true;
    }
    function rebuild() {
      /* Block 102: the two visibility rules move here from init() so they are
         re-decided per variant, not once per page. */
      if (payWrap) payWrap.hidden = !datable() || !laybyAllowed();
      if (monthsWrap) monthsWrap.hidden = plan() !== "layby";
      /* Only touch the option list when there is something to remove: an
         empty-to-empty innerHTML write is still a childList mutation, and the
         observer at the foot of init() is watching for exactly that. */
      if (!datable()) { if (dateSel.options.length) dateSel.innerHTML = ""; dateWrap.hidden = true; clearProps(); return; }
      var e = earliest(); dateSel.innerHTML = "";
      if (!e) { dateWrap.hidden = true; clearProps(); return; }
      dateWrap.hidden = false;
      var last = LG.addCalendarDays(e, 30), d = LG.cloneDate(e), first = true;
      while (d <= last) { if (LG.isWorkingDay(d)) { var o = document.createElement("option"); o.value = LG.isoLocal(d); o.textContent = fmt(d); if (first) { o.selected = true; first = false; } dateSel.appendChild(o); } d = LG.addCalendarDays(d, 1); }
      writeProps();
    }
    region.addEventListener("change", rebuild);
    root.querySelectorAll('input[name="lg-edp-pay"]').forEach(function (r) { r.addEventListener("change", function () { if (monthsWrap) monthsWrap.hidden = plan() !== "layby"; rebuild(); }); });
    if (months) months.addEventListener("change", rebuild);
    dateSel.addEventListener("change", writeProps);
    if (form) form.addEventListener("submit", function (ev) {
      if (!datable() || root.dataset.lgDateChosen === "true") return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      var panel = root.querySelector(".lg-edb__panel"); if (panel) panel.hidden = false; root.setAttribute("data-open", "true");
      if (note) { note.textContent = "Please choose your province and delivery date before adding to cart."; note.hidden = false; }
      root.scrollIntoView({ behavior: "smooth", block: "center" }); region.focus();
    }, true);
    root.dataset.lgPickerReady = "true";
    /* Block 102: the swap signal. product-info.js has already written this
       variant's data-* onto the root by the time this fires. */
    root.addEventListener("lg:variant-state", rebuild);
    rebuild();
    /* The badge script restores the saved province AFTER this init and fires no
       change event; rebuild on load and whenever the badge updates its own
       data-state / message (it does so after computing the window). */
    window.addEventListener("load", rebuild);
    /* Block 102: `datable()` is the load-bearing half of this guard now. The
       province is remembered across variants, so on a variant with nothing to
       date from - a deny-policy size at zero stock - "region chosen, no options"
       is the CORRECT resting state, not a rebuild trigger. Without the test the
       observer saw rebuild()'s own clearing of the list, called rebuild again,
       and span. */
    new MutationObserver(function () { if (datable() && region.value && !dateSel.options.length) rebuild(); })
      .observe(root, { attributes: true, subtree: true, characterData: true, childList: true });
  }
  function boot() { document.querySelectorAll(".lg-edb").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
